var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7972 12.891C18.374 13.8283 17.65 15 16.4979 15H1.50145C0.347171 15 -0.373516 13.8265 0.202171 12.891L7.70048 0.702686C8.27758 -0.235078 9.72298 -0.233379 10.299 0.702686L17.7972 12.891ZM8.99977 10.3711C8.20586 10.3711 7.56227 10.9745 7.56227 11.7188C7.56227 12.463 8.20586 13.0664 8.99977 13.0664C9.79367 13.0664 10.4373 12.463 10.4373 11.7188C10.4373 10.9745 9.79367 10.3711 8.99977 10.3711ZM7.63498 5.52697L7.8668 9.51135C7.87764 9.69779 8.04208 9.84375 8.24123 9.84375H9.7583C9.95745 9.84375 10.1219 9.69779 10.1327 9.51135L10.3645 5.52697C10.3763 5.32559 10.2052 5.15625 9.99011 5.15625H8.00939C7.79427 5.15625 7.62327 5.32559 7.63498 5.52697Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/AlertWarning.27921237bede6a737650737867780373.svg";
export { ForwardRef as ReactComponent };